import PropTypes from 'prop-types'
import React from 'react'
import config from 'SRC/config/config.yaml'

export const SelectedPackage = ({packages, selectedPackage}) =>
  <tr>
    <td className='invisible-cell' />
    {
      packages.map(
        item => item.id === selectedPackage
          ? <td key={item.id} className='izabran-paket'><a href='javascript: void (0)'>
            {config.registrationForm.package.choosePackage[1]}
          </a></td>
          : <td key={item.id} className='invisible-cell' />
      )
    }
  </tr>

SelectedPackage.propTypes = {
  packages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired
  })).isRequired,
  selectedPackage: PropTypes.number
}

SelectedPackage.defaultProps = {
  packages: []
}
